import { Component, OnInit } from '@angular/core';
import { DataService } from '../service/data.service';
import { BaseComponent } from '../base.component';
import { ActivatedRoute } from '@angular/router';
import { WindowRef } from '../windowref';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.less']
})
export class HeaderComponent extends BaseComponent implements OnInit {

  formId:string;

  constructor(data:DataService, private activatedRoute: ActivatedRoute, private winRef: WindowRef) {
    super(data);
  }

  ngOnInit() {
    
  }

  onPreview(){
   //this.data.editor.DynamicFormLayoutModel.HttpAlias
   let url = "/"+this.data.editor.DynamicFormLayoutModel.RootUrl+this.data.editor.Routes[0].Url;
    this.winRef.nativeWindow.open(url, '_blank');
  }

  onSave(){
    this.data.save();
  }

  onExport(){
    this.data.save();
    this.data.dataGET("api/dynamicforms/view/byname/getformdata/"+this.data.editor.Name.split("-")[1]).subscribe(
      data => 
      {
        /*const blob = new Blob([data["Content"]], {type: "application/vnd.ms-excel;charset=utf-8"});
        saveAs(blob, data["FileName"]);*/


        var universalBOM = "\uFEFF";
        var a = window.document.createElement('a');
        //a.setAttribute('href', 'data:text/csv; charset=utf-8,' + encodeURIComponent(universalBOM+csvString));
        a.setAttribute('download', 'example.csv');
        window.document.body.appendChild(a);
        a.click();



        var universalBOM = "\uFEFF";
        const linkSource = 'data:' + data['MimeType'] + ';base64,' + universalBOM + data['Content'];
        const downloadLink = document.createElement('a');
        document.body.appendChild(downloadLink);
        downloadLink.href = linkSource;
        downloadLink.target = '_self';
        downloadLink.download = data["FileName"];
        downloadLink.click();

      }
    );
  }
}
